import { render, staticRenderFns } from "./TrainingTea.vue?vue&type=template&id=4962ccb4&scoped=true&"
import script from "./TrainingTea.vue?vue&type=script&lang=js&"
export * from "./TrainingTea.vue?vue&type=script&lang=js&"
import style0 from "./TrainingTea.vue?vue&type=style&index=0&id=4962ccb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962ccb4",
  null
  
)

export default component.exports